import { Pipe, PipeTransform } from '@angular/core';
import {ProjectConstants} from '../app/project-constants';

@Pipe({name: 'dateString'})
export class DateStringPipe implements PipeTransform {
  transform(value: string): Date {
    const regexDate = /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/i;

    if (value != null && regexDate.test(value)) {
      return ProjectConstants.parseStringIntoDate(value);
    }

    return null;
  }
}
